import { render, staticRenderFns } from "./TransactionEventsDetails.vue?vue&type=template&id=57b2adb7"
import script from "./TransactionEventsDetails.vue?vue&type=script&lang=js"
export * from "./TransactionEventsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports